import { createSlice } from '@reduxjs/toolkit';
import getFeatureFlags from './getFeatureFlags';
export var initialState = {
    additionalInfo: false,
    creditAlreadyIssuedNav: false,
    disputesCenterDetailsModal: false,
    disputeTabs: false,
    docsRequested: false,
    redispute: false
};
var featureFlagsSlice = createSlice({
    name: 'featureFlags',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder.addCase(getFeatureFlags.fulfilled, function (state, action) {
            var payload = action.payload;
            var additionalInfo = payload.additionalInfo, creditAlreadyIssuedNav = payload.creditAlreadyIssuedNav, disputesCenterDetailsModal = payload.disputesCenterDetailsModal, disputeTabs = payload.disputeTabs, docsRequested = payload.docsRequested, redispute = payload.redispute;
            state.additionalInfo = additionalInfo;
            state.creditAlreadyIssuedNav = creditAlreadyIssuedNav;
            state.disputesCenterDetailsModal = disputesCenterDetailsModal;
            state.disputeTabs = disputeTabs;
            state.docsRequested = docsRequested;
            state.redispute = redispute;
        });
    }
});
export default featureFlagsSlice.reducer;
//# sourceMappingURL=featureFlags.slice.js.map